export default __webpack_public_path__ + "static/media/logo.1898a1c7.svg";